import Icon from '../components/Icon.vue'

Icon.register({"search":{"width":512,"height":512,"paths":[{"d":"M505 442.7L405.3 343C400.8 338.5 394.7 336 388.3 336H372C399.6 300.7 416 256.3 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208 93.1 416 208 416C256.3 416 300.7 399.6 336 372V388.3C336 394.7 338.5 400.8 343 405.3L442.7 505C452.1 514.4 467.3 514.4 476.6 505L504.9 476.7C514.3 467.3 514.3 452.1 505 442.7zM208 336C137.3 336 80 278.8 80 208 80 137.3 137.2 80 208 80 278.7 80 336 137.2 336 208 336 278.7 278.8 336 208 336z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/search.js
// module id = null
// module chunks = 